module.exports = __webpack_public_path__ + "img/ring_y_e_1_1.3c976813.png";